import { gql } from '@apollo/client';

export const GET_JOIN_BLOCKING_TASKS = gql`
  query GetJoinBlockingTasks($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        joinBlockingTasks {
          taskId
          title
          adminOnly
          managerCompleted
        }
      }
    }
  }
`;
